// src/store/services/coach.js
import feathersClient, {
  makeServicePlugin,
  BaseModel
} from "../../feathers-client";

class TraineeCompetenciesPrgms extends BaseModel {
  constructor (data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = "TraineeCompetenciesPrgms";
  // Define default properties here
  static instanceDefaults () {
    return {
      id: null,
      progressMeasure: null,
      progressMeasureId: null,
      traineeCompetenciesId: null
    };
  }
}
const servicePath = "trainee-competencies-prgms";
const servicePlugin = makeServicePlugin({
  Model: TraineeCompetenciesPrgms,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
